export default __webpack_public_path__ + "static/champion-htf-heavyweight-webfont-eb6f2b6d81fb33802fe26e0d4e479bc8.woff";